import React from 'react';

import { Avatar, Flex, Text } from '@vimeo/bokeh';
import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
import { translate } from '@vimeo/i18n-runtime';
import { UserCard, LinkOrStaticElem, getAvatarImages } from '@vimeo/user-card';

export default function UsernameAndAvatar({
  user,
  showByline,
  showCard,
  showProfile,
  showProfileLink,
  onProfileClick,
  onProfileMouseOver,
}: {
  user: User;
  showByline?: boolean;
  showCard: boolean;
  showProfile?: boolean;
  showProfileLink?: boolean;
  onProfileClick?: () => void;
  onProfileMouseOver?: () => void;
}) {
  const [avaSrc, avaSrcSet] = getAvatarImages(user?.pictures?.sizes);

  // Render nothing if both avatar and username are hidden
  if (!showProfile && !showByline) return null;

  const label = translate('Link to user profile');
  const profileUrl = showProfileLink ? user?.link : undefined;

  const content = (
    <Flex align="center" gap={75} onMouseOver={onProfileMouseOver}>
      {showProfile ? (
        <LinkOrStaticElem label={label} newTab onClick={onProfileClick} url={profileUrl}>
          <Avatar src={avaSrc} srcSet={avaSrcSet} size="sm" alt={user?.name} />
        </LinkOrStaticElem>
      ) : null}
      {showByline ? (
        <LinkOrStaticElem label={label} newTab onClick={onProfileClick} url={profileUrl}>
          <Text as="span" variant="heading-xs">
            {user?.name}
          </Text>
        </LinkOrStaticElem>
      ) : null}
    </Flex>
  );

  if (!showCard) {
    return content;
  }

  return (
    <UserCard user={user} profileUrl={profileUrl} onProfileClick={onProfileClick} openDelay={500}>
      {content}
    </UserCard>
  );
}
